import gql from 'graphql-tag'

export default gql`
  mutation createReview(
    $appointmentId: ID!
    $token: String!
    $rating: Int!
    $comment: String
  ) {
    createReview(
      appointmentId: $appointmentId
      token: $token
      rating: $rating
      comment: $comment
    )
  }
`
